import React from 'react'
import PropTypes from 'prop-types'
import LoginForm from '../../../components/LoginForm/LoginForm'
import VersionIndicator from '../../../components/VersionIndicator/VersionIndicator'

import logo from '../../../assets/hexagram_logo.svg'
import './Login.scss'

export default class Login extends React.Component {
  static contextTypes = {
    router: PropTypes.object
  };

  static propTypes = {
    isAuthenticated: PropTypes.bool,
    isAuthenticating: PropTypes.bool,
    needChangePassword: PropTypes.bool,
    loginUser: PropTypes.func,
    errorMessage: PropTypes.string,
    forgotPassword: PropTypes.func,
    forgotPasswordErrorMessage: PropTypes.string,
    isForgotPasswordLoading: PropTypes.bool,
    isForgotPasswordSuccess: PropTypes.bool,
    initForgotPassword: PropTypes.func,
  };

  static defaultProps = {
    errorMessage: ''
  };

  componentDidMount () {
    if (this.props.isAuthenticated) {
      this.context.router.replace('/')
    }
  }

  componentWillReceiveProps (nextProps) {
    if (nextProps.isAuthenticated) {
      if (nextProps.needChangePassword) {
        this.context.router.replace('/change-password')
      } else {
        this.checkMobileDevice() ? this.context.router.replace('m/patient-monitoring') : this.context.router.replace('/')
        // this.context.rousuter.replace('m/patient-monitoring')
      }
    }
  }

  checkMobileDevice = () => {
    var isMobile = false
    var sUserAgent = navigator.userAgent.toLowerCase()
    // var bIsIpad = sUserAgent.match(/ipad/i) == "ipad"
    var bIsIphoneOs = sUserAgent.match(/iphone os/i) == 'iphone os'
    var bIsMidp = sUserAgent.match(/midp/i) == "midp"
    var bIsUc7 = sUserAgent.match(/rv:1.2.3.4/i) == "rv:1.2.3.4"
    var bIsUc = sUserAgent.match(/ucweb/i) == "ucweb"
    var bIsAndroid = sUserAgent.match(/android/i) == "android"
    var bIsCE = sUserAgent.match(/windows ce/i) == "windows ce"
    var bIsWM = sUserAgent.match(/windows mobile/i) == "windows mobile"
    var bIsOM = sUserAgent.match(/opera mini/i) == "opera mini"
    var isFirefoxIOS = sUserAgent.match(/fxios/i) === 'fxios'
    // IEMobile
    if (isFirefoxIOS || bIsIphoneOs || bIsMidp || bIsUc7 || bIsUc || bIsAndroid || bIsCE || bIsWM || bIsOM) {
      isMobile = true
    }
    return isMobile
  }

  onSubmit = (loginInfo) => {
    const {
      username,
      password,
      enableRememberMe
    } = loginInfo
    this.props.loginUser({
      username,
      password,
      enableRememberMe
    })
    return false
  }

  render () {
    const wrapperStyle = {
      display: 'flex',
      flexDirection: 'column',
      justifyContent: 'center',
      alignItems: 'center',
      paddingTop: 50
    }

    const logStyle = {
      maxWidth: 200,
      width: '100%',
      marginTop: 150,
      marginBottom: 30
    }

    const formStyle = {
      maxWidth: 400,
      border:'0px solid #FFFFFF',
      color:'#FFFFFF',
      width: '80%'
    }

    const {
      errorMessage,
      isAuthenticating,
      forgotPassword,
      forgotPasswordErrorMessage,
      isForgotPasswordLoading,
      isForgotPasswordSuccess,
      initForgotPassword,
    } = this.props
    const header = (
      <div className='text-center'>
        <img src={logo} style={logStyle} />
      </div>
    )
    return (
      <div style={wrapperStyle}>
        <LoginForm
          header={header}
          style={formStyle}
          errorMessage={errorMessage}
          isAuthenticating={isAuthenticating}
          onSubmit={this.onSubmit}
          forgotPassword={forgotPassword}
          forgotPasswordErrorMessage={forgotPasswordErrorMessage}
          isForgotPasswordLoading={isForgotPasswordLoading}
          isForgotPasswordSuccess={isForgotPasswordSuccess}
          initForgotPassword={initForgotPassword}
        />
        <VersionIndicator />
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/routes/Login/components/Login.js